import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ResourceDirectivesModule } from '../directives/resource-directives.module';

import { IonicModule } from '@ionic/angular';
import { PreviewPage } from './preview.page';

import { ViewerComponent } from './viewer/viewer.component';
import { HeaderComponent } from './header/header.component';
import { AddAnnotationsModalPageModule } from '../modals/add-annotations-modal/add-annotations-modal.module';

const routes: Routes = [
  {
    path: '',
    component: PreviewPage
  }
];

@NgModule({
  imports: [
    ResourceDirectivesModule,
    CommonModule,
    FormsModule,
    IonicModule,
    AddAnnotationsModalPageModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    PreviewPage,
    ViewerComponent,
    HeaderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PreviewPageModule {}
